import React, { useState, useContext, useEffect, useRef } from "react";
import { Button, Drawer } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useLocation } from "react-router-dom";
import companyLogo from "../../../assets/images/logo.gif";
import YtLogo from "../../../assets/images/icons/youtube.png";
import FbLogo from "../../../assets/images/icons/fb.png";
import InstaLogo from "../../../assets/images/icons/insta.png";
import LinkedInLogo from "../../../assets/images/icons/linkedin.png";
import { RiArrowDownSFill } from "react-icons/ri";
import { CartCount } from "../../../context-hooks";
import { Modal, Container } from "react-bootstrap";
import ReactPlayer from "react-player";
import CoreHttpHandler from "../../../http/services/CoreHttpHandler";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
const HeaderTopComp = ({ getProducts, setSearchVal, searchVal }) => {
	const [open, setOpen] = useState(false);
	const [showDropdowm, setShowDropdowm] = useState(false);
	const [cartCount] = useContext(CartCount);
	const [tutorialVideo, setTutorialVideo] = useState(null);
	const [showVideoModal, setShowVideoModal] = useState(false);
	const navigate = useNavigate();
	const location = useLocation();

	const token = localStorage.getItem("user_token");

	const getTutorialVideos = () => {
		CoreHttpHandler.request(
			"tutorial_videos",
			"fetchAll",
			{},
			(res) => {
				const videos = res?.data?.data?.tutorialVideos || [];
				const enabledVideo = videos.find(v => v.is_enabled === true);
				if (enabledVideo) {
					setTutorialVideo(enabledVideo);
				}
			},
			(err) => {
				console.log("Error fetching tutorial videos:", err);
			}
		);
	};

	useEffect(() => {
		getTutorialVideos();
	}, []);
	const handleLogout = () => {
		localStorage.removeItem("user_token");
		window.location.reload(false);
	};
	const handleSearch = (e) => {
		e.preventDefault();
		getProducts();
		// navigate("/library");
	};
	const dropdown = useRef(null);

	useEffect(() => {
		setOpen(false);
	}, [location.pathname]);



	const googleTranslateElementInit = () => {
		new window.google.translate.TranslateElement(
			{
				pageLanguage: "en",
				includedLanguages: "en,ur",
				autoDisplay: false
			},
			"google_translate_element"
		);

		 setTimeout(() => {
        const select = document.querySelector(".goog-te-combo");
        if (select) {
            // Create "Select Language" default option
            const defaultOption = document.createElement("option");
            defaultOption.textContent = "Select Language";
            defaultOption.value = "";
            defaultOption.selected = true;
            defaultOption.disabled = true;

            // Add default option if not already present
            if (!select.querySelector('option[value=""]')) {
                select.insertBefore(defaultOption, select.firstChild);
            }

            // Listen for dropdown changes and store user selection
            select.addEventListener("change", () => {
                const newLang = select.value;
                if (newLang) {
                    sessionStorage.setItem("userSelectedLang", newLang);
                    select.dispatchEvent(new Event("change")); // Ensure translation applies
                }
            });
        }
    }, 2000);
		
	};

	useEffect(() => {
		const addScript = document.createElement("script");
		addScript.setAttribute(
			"src",
			"//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
		);
		document.body.appendChild(addScript);
		window.googleTranslateElementInit = googleTranslateElementInit;

		const style = document.createElement("style");
		style.innerHTML = `
			.goog-logo-link {
				display: none !important;
			}
			.goog-te-gadget {
				font-size: 0 !important;
				span {
					display: none !important;
				}
			}
			.goog-te-combo {
				padding: 5px;
			}
			#google_translate_element {
				@media (max-width: 767px) {
					margin: auto;
				}
			}
		`;
		document.head.appendChild(style);
	}, []);

	return (
		<>
			<div className='top_head'>
				<div className="logo_wrap">
					<Link to='/'>
						<img
							src={companyLogo}
							// width="100%"
							alt='image'
						/>
					</Link>
					{tutorialVideo && (
						<div
							className="tutorial-btn"
							onClick={() => setShowVideoModal(true)}
							style={{ cursor: "pointer" }}
						>
							<h6><PlayCircleOutlineIcon />{" "}{tutorialVideo.title}</h6>
						</div>
					)}
				</div>
				
				<div className='container'>
					<div className='inner-wrap'>
						<div className="box">
							<h6><LocalPhoneIcon />{" "}(+92 (21) 35306673 / +92 (21) 35306674)</h6>
							<h6><EmailIcon />{" "}<a href="mailto:governance@picg.org.pk">governance@picg.org.pk</a></h6>
						</div>
						<div id="google_translate_element"></div>
					</div>
				</div>
			</div>

			{/* Tutorial Video Modal */}
			<Modal
				backdrop="static"
				centered
				dialogClassName="modal-90w"
				keyboard={false}
				show={showVideoModal}
				onHide={() => setShowVideoModal(false)}
				aria-labelledby="tutorial-video-modal"
			>
				<Modal.Header className="modal-bg" closeButton>
					<Modal.Title id="tutorial-video-modal">
						{tutorialVideo?.title}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="grid-example modal-bg">
					<Container>
						<ReactPlayer
							controls
							url={tutorialVideo?.video_url}
							width="100%"
							style={{ minHeight: "60vh", maxHeight: "80vh" }}
						/>
					</Container>
				</Modal.Body>
			</Modal>
		</>
	);
};

export default HeaderTopComp;
